import React from "react";

// Reusable pure-SVG ring gauge. Guarantees a perfect circle (square viewBox) and
// a perfectly centered value label (text-anchor=middle + dominant-baseline=central),
// avoiding the sub-pixel drift of overlay-based recharts gauges.
export function RingGauge({
  value = 0,
  size = 72,
  stroke = 8,
  color = "#0B7E8C",
  track = "#F1F5F9",
  label,
  trend,
  valueColor = "#1F2937",
  suffix = "%",
  testId,
}) {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  const c = size / 2;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const dash = (v / 100) * circ;

  return (
    <div className="text-center" data-testid={testId}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="block mx-auto">
        <circle cx={c} cy={c} r={r} fill="none" stroke={track} strokeWidth={stroke} />
        {v > 0 && (
          <circle
            cx={c} cy={c} r={r} fill="none" stroke={color} strokeWidth={stroke}
            strokeDasharray={`${dash} ${circ - dash}`} strokeLinecap="round"
            transform={`rotate(-90 ${c} ${c})`}
          />
        )}
        <text
          x={c} y={c} textAnchor="middle" dominantBaseline="central"
          fontSize={size * 0.24} fontWeight="700" fill={valueColor}
        >
          {Math.round(v)}{suffix}
        </text>
      </svg>
      {label && <div className="text-[10px] uppercase tracking-wider text-[#6B7280] mt-1">{label}</div>}
      {trend != null && (
        <div className={`text-[10px] ${trend > 0 ? "text-[#10B981]" : "text-[#EF4444]"}`}>
          {trend > 0 ? "▲" : "▼"} {Math.abs(trend)}% vs yesterday
        </div>
      )}
    </div>
  );
}

export default RingGauge;
